import React from 'react';
import { Link } from 'react-router-dom';

function RichCard({ imgUrl, title, text, size = 64, to, ...rest }) {
  return (
    <div
      {...rest}
      className={`flex flex-col items-center text-center p-4 rounded-sm bg-white shadow-sm cursor-pointer ${
        rest.className ? rest.className : ''
      }`}
    >
      <div className="flex items-center justify-center h-16">
        <img height={size} width={size} src={imgUrl} alt={title} className="object-contain" />
      </div>
      <div className="pt-6 pb-2">
        <h3 className="text-xl font-bold" style={{ fontFamily: 'SF Pro Display, sans-serif' }}>
          {title}
        </h3>
      </div>
      <div className="flex-grow flex flex-col justify-start h-24"> {/* Key Changes Here */}
        <p className="text-base text-slate-600 pt-6 font-normal" style={{ fontFamily: 'SF Pro Display, sans-serif' }}>
          {text}
        </p>
      </div>
    </div>
  );
}

export default RichCard;